import Vue from 'vue';
import { apiV2Client } from '@/services/client/ApiClient.js';

const WIZARD_COOKIE_NAME = 'su_wzd';

export default {
  get(id) {
    return apiV2Client.get(`/wizards/${id}`, { useCache: true });
  },

  getWizardState() {
    const cookie = Vue.$cookies.get(WIZARD_COOKIE_NAME);

    if (!cookie) {
      return {
        openOnLoad: true // pri prvnim nacteni stranky otevre pruvodce
      };
    }

    return cookie;
  },

  setWizardState(state) {
    Vue.$cookies.set(WIZARD_COOKIE_NAME, JSON.stringify(state), Infinity);
  }
};
